"use client";
import { useEffect, useState } from "react";
import { Box, Divider, FormHelperText, Typography } from "@mui/material";

import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";

import {
  CFormHelperText,
  ContainedButton,
  CTextField,
  GetPhoneInputStyles,
} from "./CustomStyles";
import axios from "axios";
import { CustomFormLabel, SignInWithButton } from "./CustomStyles";
import { Poppins } from "next/font/google";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { isValidEmail } from "../../hooks/HelperFunctions";
import SimpleBackdrop from "../Backdrop/SimpleBackdrop";
import PhoneField from "phonecomponent/src/PhoneField/PhoneField";
const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const Welcome = (props) => {
  const {
    email,
    phone,
    setEmail,
    setPhone,
    signInWith,
    setAuthSteps,
    setSignInWith,
    welcomeButtonFn,
    setPhoneFormatted,
    showToastWithMessage,
  } = props;

  const [phoneFieldError, setPhoneFieldError] = useState(true);
  const [phoneError, setPhoneError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  //* ================================================== phone component =========================================================== *//
  const [phoneNumber, setPhoneNumber] = useState("");
  const onChangePhone = (contryCode, phoneFormatted) => {
    setPhoneNumber(`${contryCode} ${phoneFormatted}`?.replace(/[^\d+]/g, ""));
    setPhoneFormatted(`${contryCode} ${phoneFormatted}`);
  };
  const clearPhoneError = () => {
    setPhoneError("");
  };

  const handleCountryChangeReset = () => {
    setPhoneNumber("");
    setPhoneFormatted("");
  };
  useEffect(() => {
    setPhone(phoneNumber);
  }, [phoneNumber]);
  //* ================================================== phone component =========================================================== *//

  //================== google recapcha v3 part start ====================//
  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`;
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  //================== google recapcha v3 part end ====================//

  const handleSignInWith = () => {
    if (signInWith === "email") {
      setSignInWith("phone");
    } else {
      setSignInWith("email");
    }
  };
  const sendEmailHandler = () => {
    if (!isValidEmail(email)) {
      setEmailError("Enter a valid email address");
      setShowLoader(false);
      return false;
    }
    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["email"] = `${email}`;
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendEmailForCheckExistence`, postData)
          .then((response) => {
            setShowLoader(false);
            if (response?.data?.found) {
              setAuthSteps(1);
            } else {
              setAuthSteps(6);
            }
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };
  const sendPhoneHandler = () => {
    if (phone?.length < 9) {
      setPhoneError("Enter a valid phone number");
      setShowLoader(false);
      return false;
    }

    let postData = {};
    window.grecaptcha.ready(async () => {
      try {
        const token = await window.grecaptcha.execute(
          `${process.env.NEXT_PUBLIC_API_URL_GOOGLE_RECAPTCHA_SITE_KEY}`,
          { action: "submit" }
        );
        ///===================== recapcha ==============================///
        postData["phone"] = `${phone}`;
        postData["token"] = token;
        postData["invite_token"] = props?.invite_token;
        postData["invitationFrom"] =
          props?.invitationFrom && props?.invitationFrom != ""
            ? props?.invitationFrom
            : "";
        console.log(postData);

        const baseUrl =
          process.env.NEXT_PUBLIC_PROJECT_ENV === "prod"
            ? process.env.NEXT_PUBLIC_API_URL_PROD
            : process.env.NEXT_PUBLIC_API_URL_DEV;

        axios
          .post(`${baseUrl}/sendPhoneForLoginSignup`, postData)
          .then((response) => {
            setShowLoader(false);
            showToastWithMessage("Code sent");

            setAuthSteps(2);
          })
          .catch((err) => {
            setShowLoader(false);
            console.log(err);
            if (err?.response?.data?.message) {
            }
          });
      } catch (error) {
        setShowLoader(false);
        console.error("Error:", error);
      }
    });
  };

  const continueHandler = () => {
    setShowLoader(true);
    if (signInWith == "email") {
      localStorage.setItem("lastTimeLoggedInWith", "email")
      sendEmailHandler();
    } else {
      localStorage.setItem("lastTimeLoggedInWith", "phone")
      sendPhoneHandler();
    }
  };
  return (
    <Box>
      <Box>
        <Typography
          sx={{
            color: "#0B132B",
            fontFamily: poppins.style.fontFamily,
            fontSize: "clamp(20px, 5vw, 24px)",
            fontWeight: 600,
          }}
        >
          Welcome to Takbir
        </Typography>
        <Box
          sx={{ mt: 4, display: "flex", flexDirection: "column", gap: "32px" }}
        >
          {signInWith === "email" ? (
            <form>
              <CustomFormLabel>Email address</CustomFormLabel>
              <CTextField
                placeholder="Enter email address"
                type="email"
                onChange={(e) => {
                  setEmail(e.target.value.toLowerCase());
                  setEmailError("");
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    continueHandler();
                  }
                }}
                value={email}
                helperText={emailError}
                error={emailError != ""}
              />
            </form>
          ) : (
            <Box>
              <CustomFormLabel>Phone number</CustomFormLabel>
              <div
                // className={"PhoneFieldManContainer"}
                className={`PhoneFieldManContainer ${
                  phoneError ? "error" : ""
                }`}
              >
                <PhoneField
                  helperText=""
                  Search={false}
                  error={phoneError != ""}
                  phone={phoneNumber}
                  maxDigits={11}
                  onChangePhone={onChangePhone}
                  clearPhoneError={clearPhoneError}
                  handleCountryChangeReset={handleCountryChangeReset}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      continueHandler();
                    }
                  }}
                  BrOPen="("
                  BrClose=")"
                />

                {phoneError != "" ? (
                  <CFormHelperText error sx={{ marginTop: "0px" }}>
                    {phoneError}
                  </CFormHelperText>
                ) : (
                  <CFormHelperText sx={{ marginTop: "0px", color: "#5C677D" }}>
                    We’ll text you to confirm your phone number. <br />
                    Standard data rates may apply.
                  </CFormHelperText>
                )}
              </div>
            </Box>
          )}
          <ContainedButton
            variant="contained"
            fullWidth
            // onClick={welcomeButtonFn ? welcomeButtonFn : undefined}
            onClick={(e) => {
              if (signInWith == "phone" && phone.length >= 9) {
                continueHandler();
              } else {
                continueHandler();
              }
            }}
            endIcon={<ArrowForwardRoundedIcon />}
          >
            Continue with {signInWith === "email" ? "email" : "phone"}
          </ContainedButton>
          <Divider sx={{ borderColor: "#E4E8EC", color: "#676C7B" }}>
            or
          </Divider>
          <SignInWithButton
            variant="outlined"
            fullWidth
            startIcon={
              signInWith === "email" ? (
                <LocalPhoneOutlinedIcon />
              ) : (
                <MailOutlinedIcon />
              )
            }
            onClick={handleSignInWith}
          >
            <span className="text">
              Continue with {signInWith === "email" ? "phone" : "email"}
            </span>
          </SignInWithButton>
          {/* <SignInWithButton
            variant="outlined"
            fullWidth
            startIcon={<GoogleSvg />}
            // onClick={handleSignInWith}
          >
            <span className="text">Continue with Google</span>
          </SignInWithButton> */}
        </Box>
      </Box>
      <SimpleBackdrop open={showLoader} />
    </Box>
  );
};

export default Welcome;

const GoogleSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 128 128"
    >
      <path
        fill="#fff"
        d="M44.59 4.21a63.28 63.28 0 0 0 4.33 120.9a67.6 67.6 0 0 0 32.36.35a57.13 57.13 0 0 0 25.9-13.46a57.44 57.44 0 0 0 16-26.26a74.3 74.3 0 0 0 1.61-33.58H65.27v24.69h34.47a29.72 29.72 0 0 1-12.66 19.52a36.2 36.2 0 0 1-13.93 5.5a41.3 41.3 0 0 1-15.1 0A37.2 37.2 0 0 1 44 95.74a39.3 39.3 0 0 1-14.5-19.42a38.3 38.3 0 0 1 0-24.63a39.25 39.25 0 0 1 9.18-14.91A37.17 37.17 0 0 1 76.13 27a34.3 34.3 0 0 1 13.64 8q5.83-5.8 11.64-11.63c2-2.09 4.18-4.08 6.15-6.22A61.2 61.2 0 0 0 87.2 4.59a64 64 0 0 0-42.61-.38"
      ></path>
      <path
        fill="#e33629"
        d="M44.59 4.21a64 64 0 0 1 42.61.37a61.2 61.2 0 0 1 20.35 12.62c-2 2.14-4.11 4.14-6.15 6.22Q95.58 29.23 89.77 35a34.3 34.3 0 0 0-13.64-8a37.17 37.17 0 0 0-37.46 9.74a39.25 39.25 0 0 0-9.18 14.91L8.76 35.6A63.53 63.53 0 0 1 44.59 4.21"
      ></path>
      <path
        fill="#f8bd00"
        d="M3.26 51.5a63 63 0 0 1 5.5-15.9l20.73 16.09a38.3 38.3 0 0 0 0 24.63q-10.36 8-20.73 16.08a63.33 63.33 0 0 1-5.5-40.9"
      ></path>
      <path
        fill="#587dbd"
        d="M65.27 52.15h59.52a74.3 74.3 0 0 1-1.61 33.58a57.44 57.44 0 0 1-16 26.26c-6.69-5.22-13.41-10.4-20.1-15.62a29.72 29.72 0 0 0 12.66-19.54H65.27c-.01-8.22 0-16.45 0-24.68"
      ></path>
      <path
        fill="#319f43"
        d="M8.75 92.4q10.37-8 20.73-16.08A39.3 39.3 0 0 0 44 95.74a37.2 37.2 0 0 0 14.08 6.08a41.3 41.3 0 0 0 15.1 0a36.2 36.2 0 0 0 13.93-5.5c6.69 5.22 13.41 10.4 20.1 15.62a57.13 57.13 0 0 1-25.9 13.47a67.6 67.6 0 0 1-32.36-.35a63 63 0 0 1-23-11.59A63.7 63.7 0 0 1 8.75 92.4"
      ></path>
    </svg>
  );
};
